// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import type { Attachment, Practitioner } from '@medplum/fhirtypes';

export const PROVIDER_SIGNATURE_EXTENSION = 'https://polarissleep.com/fhir/StructureDefinition/provider-signature';

export function getProviderSignature(practitioner: Practitioner): Attachment | undefined {
  return practitioner.extension?.find((extension) => extension.url === PROVIDER_SIGNATURE_EXTENSION)?.valueAttachment;
}

export function setProviderSignature(practitioner: Practitioner, signature: Attachment): Practitioner {
  return {
    ...practitioner,
    extension: [
      ...(practitioner.extension?.filter((extension) => extension.url !== PROVIDER_SIGNATURE_EXTENSION) ?? []),
      { url: PROVIDER_SIGNATURE_EXTENSION, valueAttachment: signature },
    ],
  };
}

export function clearProviderSignature(practitioner: Practitioner): Practitioner {
  return {
    ...practitioner,
    extension: practitioner.extension?.filter((extension) => extension.url !== PROVIDER_SIGNATURE_EXTENSION),
  };
}
